import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { usePermission } from 'providers/RightsHooks';
import { ADMIN_GENERIC_FILTER_PARAMS_WRITE } from 'constants/rightsCodes';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { IconButton } from '@totalsoft/rocket-ui';
import TextTableCell from 'components/common/table/TextTableCell';

const GenericFilterParamItem = ({ data }) => {
  const { t } = useTranslation();
  const historyContext = useHistoryWithContext();
  const canWrite = usePermission(ADMIN_GENERIC_FILTER_PARAMS_WRITE);

  const handleEdit = useCallback(() => {
    historyContext.push(`/genericFilterParams/${data.paramId}`);
  }, [historyContext, data]);

  return (
    <TableRow>
      <TextTableCell content={data.paramCode} />
      <TableCell>{data.paramName}</TableCell>
      <TableCell align='right'>
        <IconButton color='primary' size='small' variant='text' type='edit' tooltip={t('Edit')} disabled={!canWrite} onClick={handleEdit} />
      </TableCell>
    </TableRow>
  );
};

GenericFilterParamItem.propTypes = {
  data: PropTypes.object.isRequired
};

export default GenericFilterParamItem;
